var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-field',{attrs:{"id":"email-field","validation":_vm.$v,"validationMessage":_vm.validationMessage,"warningMessage":_vm.warningMessage,"forceInvalid":_vm.forceInvalid,"label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textLabel
      : null,
    autocomplete: 'email',
    name: 'email',
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},on:{"input":_vm.input,"blur":_vm.blur},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})}
var staticRenderFns = []

export { render, staticRenderFns }